import React, {useCallback} from "react"
import {PaginatedSelector} from "@/components/paginated-selector/paginated-selector";
import {apiV2} from "@/api/axiosConfig";
import {convertV1ToV2, PaginatedResponse} from "@/types/PaginatedResponse";
import {FilterQueryParams} from "@/components/paginated-selector/filters/types";

type Facility = {
    id: string;
    name: string;
    clientID: string;
    clientName: string;
    address: {
        formatted: string;
    };
}

type FacilitySelectorSimpleProps = {
    clientID?: string;
    departmentID?: string;
    selectedIDs?: string[];
    setSelectedIDs?: (selectedIDs: string[]) => void;
}

export function FacilitySelectorSimple({clientID, departmentID, selectedIDs = [], setSelectedIDs}: FacilitySelectorSimpleProps) {
    const headers = [
        "Name",
        "Address"
    ]

    const getFacilities = useCallback(async (search: string, page: number, filterParams?: FilterQueryParams) => {
        const params: any = {
            search: search,
            page: page,
            limit: 10,
            ...filterParams,
        }

        if (clientID) {
            params.clientID = clientID;
        }

        if (departmentID) {
            params.departmentID = departmentID;
        }

        const res = await apiV2.get<PaginatedResponse<any>>("facilities", {params})

        return convertV1ToV2(res.data, 10)
    }, [clientID, departmentID])

    const getColumns = useCallback((facility: Facility) => {
        return [
            facility.name,
            facility.address?.formatted || ""
        ]
    }, [])

    return <PaginatedSelector
        headers={headers}
        getItems={getFacilities}
        getColumns={getColumns}
        selectedIDs={selectedIDs}
        setSelectedIDs={setSelectedIDs}
        disableSelect={false}
        showSelectionCount={true}
    />
}
